import type { PrincipleRow } from '../../datagovernance/framework';

type Props = { items?: PrincipleRow[] };

export function DataPrinciplesPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.principle} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.principle}</p>
            <span className="shrink-0 text-sm font-semibold text-brand-600">{item.score}%</span>
          </div>
          <div className="mt-2 h-1.5 rounded-full bg-slate-100 dark:bg-slate-800">
            <div className="h-1.5 rounded-full bg-brand-500" style={{ width: `${item.score}%` }} />
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.status}</p>
        </div>
      ))}
    </div>
  );
}
